import React from "react";

const Description = () => {
  return (
    <div>
      <h2>Description </h2>
      <hr />
      <p>
        This API provides detailed information about Jelly Belly beans,
        including facts, milestones, recipes, and bean details. It is designed
        to be a comprehensive resource for Jelly Belly enthusiasts and
        researchers.
      </p>
    </div>
  );
};

export default Description;
